import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export const VEHICLE_TYPE_NOT_DETECTED_MESSAGE =
  'Tipo do veículo não detectado para essa placa. Por favor, comunique o administrador.';

interface VehicleNotIdentifiedModalProps {
  /** Whether the modal is visible. */
  open: boolean;
  /** Called when the user taps "Tentar novamente". */
  onClose: () => void;
}

const VehicleNotIdentifiedModal: React.FC<VehicleNotIdentifiedModalProps> = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="vehicle-not-identified-title"
    aria-describedby="vehicle-not-identified-description"
    data-testid="vehicle-not-identified-modal"
  >
    <DialogTitle
      id="vehicle-not-identified-title"
      sx={{ fontFamily: "'Poppins' !important", fontWeight: 600}}
    >
      Não conseguimos identificar<br />o veículo
    </DialogTitle>
    <DialogContent>
      <DialogContentText
        id="vehicle-not-identified-description"
        data-testid="vehicle-not-identified-description"
        sx={{ fontFamily: "'Poppins' !important" }}
      >
        Verifique se a placa foi digitada corretamente e tente novamente. <br/> Caso o problema persista, entre em contato com o nosso suporte.
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ padding: '0 24px 20px' }}>
      <Button
        fullWidth
        variant="contained"
        className="black-button"
        onClick={onClose}
        data-testid="vehicle-not-identified-retry"
        sx={{ textTransform: 'none !important' }}
      >Tentar novamente</Button>
    </DialogActions>
  </Dialog>
);

export default VehicleNotIdentifiedModal;
